import { PolicyLinkedToAnotherEmailScreensComponent } from '../../../../components/screens/signup-process/policy-linked-to-another-email-screens/policy-linked-to-another-email-screens.component';
import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

import { UserService } from '../../../../_services/user.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent, PolicyLinkedToAnotherEmailScreensComponent],
  selector: 'app-signup-policy-linked-to-another-email',
  templateUrl: './signup-policy-linked-to-another-email.component.html',
})
export class SignupPolicyLinkedToAnotherEmailComponent implements OnInit {
  message: any;
  user: any;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.$user.subscribe((user) => {
      this.user = user;
      const email = user.b2cEmail.split('@');
      const email1 = email[0].split('').map((char, i) => {
        if (i > 1) {
          return '*';
        } else {
          return char;
        }
      });
      const com = email[1].split('.');
      const email2 = com[0].split('').map((chars, i) => {
        if (i > 1) {
          return '*';
        } else {
          return chars;
        }
      });
      this.message = email1.join('') + '@' + email2.join('') + '.' + com[1];
    });
  }
}
